import Mousetrap from 'mousetrap';
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

class KeyTrap extends React.Component {
    constructor(props) {
        super(props);
        this.handleEvent = this.handleEvent.bind(this);
    }
    componentDidMount() {
        Mousetrap.bind(this.props.on, this.handleEvent);
    }
    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.on, this.props.on)) {
            Mousetrap.unbind(this.props.on);
            Mousetrap.bind(nextProps.on, this.handleEvent);
        }
    }
    componentWillUnmount() {
        Mousetrap.unbind(this.props.on);
    }
    handleEvent(event) {
        this.props.handleEvent(event);
    }
    render() {
        return null;
    }
}

KeyTrap.propTypes = {
    handleEvent: PropTypes.func.isRequired,
    on: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
    ]).isRequired,
};

export default KeyTrap;



// WEBPACK FOOTER //
// ./src/client/Components/KeyTrap/KeyTrap.js